import { CursedLibraryApp } from './CursedLibraryApp';
/**
 * @fileoverview Main script for the Cursed Library app.
 *  This is the entry point for the app.
 */

document.addEventListener('DOMContentLoaded', () => new CursedLibraryApp());